/*
 * assets/dkk-price.js
 *
 * Cenu v dánskych korunách dá dopredu, cenu v eurách zmenší
 * na sivý riadok pod ňu a doplní poznámku o mene platby.
 *
 * Euro sa zámerne neskrýva — účtuje sa v ňom a na checkoute sa
 * objaví. Ak by na stránke nebolo, zákazník by ho videl až
 * pri platbe a dánske pravidlá označovania cien vyžadujú, aby
 * konečná cena bola uvedená.
 *
 * Zapojenie: v layout/theme.liquid pred </body>
 *   {%- if request.locale.iso_code == 'da' -%}
 *     <script src="{{ 'dkk-price.js' | asset_url }}" defer></script>
 *   {%- endif -%}
 */
(function () {
  'use strict';

  /* --- nastavenia ------------------------------------------------- */

  /*
   * DKK je cez ERM II naviazaná na euro na centrálnom kurze 7,46038
   * s pásmom +/- 2,25 %. Dánska národná banka ho drží tesne.
   */
  var RATE = 7.46;

  var PREFIX = 'ca. ';
  var DASH = ' – ';
  var NOTE = 'Vejledende pris. Betaling sker i EUR.';

  /* --- štart ------------------------------------------------------ */

  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('da') !== 0) return;

  injectStyles();

  /* --- formátovanie ----------------------------------------------- */

  function formatDkk(eur) {
    var ore = Math.round(eur * 100 * RATE);
    var kr = Math.floor(ore / 100);
    var rest = ore % 100;
    var krStr = String(kr).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return krStr + ',' + String(rest).padStart(2, '0') + ' kr.';
  }

  function formatSpan(list) {
    var lo = Math.min.apply(null, list);
    var hi = Math.max.apply(null, list);
    if (lo === hi) return PREFIX + formatDkk(lo);
    return PREFIX + formatDkk(lo) + DASH + formatDkk(hi);
  }

  function parseEur(text) {
    var out = [];
    var re = /(\d[\d.\u00a0]*?)(?:,(\d{1,2}))?\s*€/g;
    var m;
    while ((m = re.exec(text)) !== null) {
      var whole = m[1].replace(/[.\u00a0]/g, '');
      if (!whole) continue;
      var value = parseFloat(whole);
      if (m[2]) value += parseFloat(m[2].padEnd(2, '0')) / 100;
      if (!isNaN(value)) out.push(value);
    }
    return out;
  }

  /* --- pomocné ---------------------------------------------------- */

  function isVisible(el) {
    if (!el.getClientRects().length) return false;
    var s = getComputedStyle(el);
    return s.visibility !== 'hidden' && s.opacity !== '0';
  }

  function classOf(el) {
    return typeof el.className === 'string' ? el.className : '';
  }

  /* Pôvodná cena podľa štruktúry, nie podľa veľkosti čísla. */
  function isCompare(el, root) {
    var n = el;
    while (n) {
      if (n.tagName === 'S' || n.tagName === 'DEL') return true;
      if (/compare|was|old|regular|strike|before|list-price/i.test(classOf(n))) {
        return true;
      }
      var s = getComputedStyle(n);
      var td = s.textDecorationLine || s.textDecoration || '';
      if (td.indexOf('line-through') !== -1) return true;
      if (n === root) break;
      n = n.parentElement;
    }
    return false;
  }

  function amountNodes(root) {
    var all = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    var hits = all.filter(function (el) {
      if (el.closest('.dkk-price')) return false;
      if (!isVisible(el)) return false;
      return parseEur(el.textContent).length > 0;
    });
    return hits.filter(function (el) {
      return !hits.some(function (other) {
        return other !== el && el.contains(other);
      });
    });
  }

  /* --- hľadanie cenových blokov ----------------------------------- */

  function findPriceRoots() {
    var nodes = document.querySelectorAll(
      '[class*="price" i], [class*="money" i], [data-price]'
    );
    var candidates = [];

    nodes.forEach(function (el) {
      if (el.closest('.dkk-price')) return;
      if (!isVisible(el)) return;
      if (!amountNodes(el).length) return;
      candidates.push(el);
    });

    return candidates.filter(function (el) {
      return !candidates.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  /* --- vykreslenie ------------------------------------------------ */

  function render(root) {
    var sales = [];
    var compares = [];

    amountNodes(root).forEach(function (el) {
      var amounts = parseEur(el.textContent);
      if (!amounts.length) return;
      var bucket = isCompare(el, root) ? compares : sales;
      amounts.forEach(function (a) {
        bucket.push(a);
      });
    });

    if (!sales.length && compares.length) {
      sales = compares;
      compares = [];
    }
    if (!sales.length) return;

    var showCompare =
      compares.length &&
      Math.max.apply(null, compares) > Math.max.apply(null, sales);

    /* DKK ide NAD cenu v eurách. */
    var block = root.previousElementSibling;
    if (!block || !block.classList.contains('dkk-price')) {
      block = document.createElement('div');
      block.className = 'dkk-price';
      root.insertAdjacentElement('beforebegin', block);
    }

    var html = '';
    if (showCompare) {
      html += '<s class="dkk-price__compare">' + formatSpan(compares) + '</s>';
    }
    html += '<span class="dkk-price__sale">' + formatSpan(sales) + '</span>';
    if (block.innerHTML !== html) block.innerHTML = html;

    /* Euro zmenšiť a stlmiť. */
    root.classList.add('dkk-eur');

    /* Poznámka pod euro. */
    var note = root.nextElementSibling;
    if (!note || !note.classList.contains('dkk-eur-note')) {
      note = document.createElement('div');
      note.className = 'dkk-eur-note';
      note.textContent = NOTE;
      root.insertAdjacentElement('afterend', note);
    }
  }

  function renderAll() {
    findPriceRoots().forEach(render);
  }

  /* --- štýly ------------------------------------------------------ */

  function injectStyles() {
    var css =
      /* koruny — hlavná cena */
      '.dkk-price{display:flex;align-items:baseline;flex-wrap:wrap;gap:.5rem;' +
      'line-height:1.25}' +
      '.dkk-price__compare{color:var(--color-compare-price,rgba(0,0,0,.5));' +
      'text-decoration:line-through;font-size:1em}' +
      '.dkk-price__sale{color:var(--color-sale-price,#d72c0d);' +
      'font-weight:700;font-size:1.2em}' +
      /* euro — stlmený riadok pod tým */
      '.dkk-eur{font-size:.8em!important;margin-top:.15rem}' +
      '.dkk-eur,.dkk-eur *{color:rgba(0,0,0,.55)!important;' +
      'font-weight:400!important}' +
      /* poznámka */
      '.dkk-eur-note{font-size:.75em;color:rgba(0,0,0,.5);margin-top:.1rem;' +
      'line-height:1.3}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* --- sledovanie zmien ------------------------------------------- */

  var scheduled = false;
  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (m) {
      var t = m.target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!el) return false;
      return !el.closest('.dkk-price') && !el.closest('.dkk-eur-note');
    });
    if (!relevant || scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      renderAll();
    });
  });

  function start() {
    renderAll();
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();